import PackageFeatureOverviewLayout from './PackageFeaturesOverview'

const ROUTES = [
  PackageFeatureOverviewLayout
]

export default ROUTES
